<template>
  <div id="obra-toolbar-obra">
    <v-toolbar flat>
      <v-btn v-if="mostrarBtnRegresar" icon>
        <v-icon> mdi-chevron-left </v-icon>
      </v-btn>
      <v-toolbar-title class="display-1">
        {{ titulo }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
  </div>
</template>

<script>

export default {
  name: 'TituloToolBarObra',
  props: {
    titulo: {
      type: String,
      required: false,
      default: '# Obra',
    },

    mostrarBtnRegresar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style lang="scss">
</style>
